module.exports = __webpack_public_path__ + "media/images/sliders-896fab82799f8d8a126a30d0610d0e02.svg";